<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Admins</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home >
            </router-link>
            <span class="breadcrumb-item active">Admins</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <div class="row">
              <div class="col-lg-12 add-form mb-4 d-flex justify-content-end">
                <router-link :to="`/add-admin`">
                  <button class="btn btn-info">Add New Admin</button>
                </router-link>
              </div>
            </div>
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Last Updated</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="admin in admins" :key="admin.id">
                    <td>{{admin.id}}</td>
                    <td>{{admin.name}}</td>
                    <td>{{admin.email}}</td>
                    <td>{{admin.updated_at}}</td>
                    <td>
                      <i class="fa fa-trash fa-icons" @click="deleteAdmin(admin.id)" aria-hidden="true"></i>
                      <router-link :to="`/edit-admin/` + admin.id">
                        <i class="fas fa-pencil-alt fa-icons ml-md-1"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Wrapper END -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Admin from '@/models/admin'
export default {
  name: 'Admins',
  data () {
    return {
      datatable: null,
      admins: []
    }
  },
  computed: {
    isLoading () {
      if (this.admins.length === 0) { return this.$store.getters.apiStatus === 'loading' } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)

    let naturalScript = document.createElement('script')
    naturalScript.setAttribute('src', 'https://cdn.datatables.net/plug-ins/1.10.16/sorting/natural.js')
    document.head.appendChild(naturalScript)
    this.fetchAllAdmins()
  },
  methods: {
    fetchAllAdmins () {
      this.admins = []
      this.$store.dispatch('fetchAllAdmins')
        .then((result) => {
          result.data.admins.forEach(admin => {
            this.admins.push(new Admin(admin))
          })
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    deleteAdmin (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this admin?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteAdmin', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllAdmins()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        pagingType: 'full_numbers',
        'order': [[ 0, 'desc' ]],
        columnDefs: [
          {
            targets: 4,
            'orderable': false
          }
        ],
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Admin/Admins.vue